import React, { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import { useAppSelector } from 'store/hooks';
import { Button, CardView, rem } from 'design-system';
import Text from 'design-system/Text';
import useEnergyCompare from 'features/feed/components/save/useEnergyCompare';
import { selectFeatureFlag } from 'reducers/selectors';
import { useMainStackNavigation } from 'utils/types/navigationV6';
const strings = {
    title: 'Put utility bills in your name',
    subTitle: 'A mobile contract or energy bill paid by Direct Debit shows lenders you’re a reliable payer.',
    buttonBroadband: 'View broadband deals',
    buttonEnergy: 'View energy deals',
};
const UtilitiesCard = () => {
    const navigation = useMainStackNavigation();
    const onCompare = useCallback((routeWithParams) => {
        navigation.navigate(routeWithParams);
    }, []);
    const energyCompare = useEnergyCompare(onCompare);
    const hasEnergy = useAppSelector((store) => selectFeatureFlag(store, 'energy_switch_two').value);
    const onPressBroadband = useCallback(() => energyCompare('Broadband'), [energyCompare]);
    const onPressEnergy = useCallback(() => energyCompare('Energy'), [energyCompare]);
    return (<CardView withPadding noMarginTop style={styles.card}>
      <View style={styles.textContainer}>
        <Text Text-16 flex>
          {strings.title}
        </Text>
        <Text TextThin-14 Secondary>
          {strings.subTitle}
        </Text>
      </View>
      <View style={styles.buttonContainer}>
        <Button onPress={onPressBroadband} square brandReversed title={strings.buttonBroadband}/>
        {!!hasEnergy && (<Button onPress={onPressEnergy} square brandReversed title={strings.buttonEnergy}/>)}
      </View>
    </CardView>);
};
const styles = StyleSheet.create({
    card: {
        gap: rem(16),
    },
    textContainer: {
        gap: rem(4),
    },
    buttonContainer: {
        gap: rem(12),
    },
});
export default UtilitiesCard;
